import type { ComponentType } from 'react';
import BlackFridayPromoBannerContent from './BlackFridayPromoBannerContent';
import JanuaryPromoBannerContent from './JanuaryPromoBannerContent';

export interface BannerContentProps {
    promoCode: string;
    buttonText: string;
}

export const BANNER_CONTENT_COMPONENT_MAP: Record<
    string,
    ComponentType<BannerContentProps>
> = {
    blackFriday: BlackFridayPromoBannerContent,
    january: JanuaryPromoBannerContent
};

export type BannerContentType = keyof typeof BANNER_CONTENT_COMPONENT_MAP;
